import {
  GET_YOUTUBE_VIDEOS,
  GET_YOUTUBE_VIDEOS_SUCCESS,
  GET_YOUTUBE_VIDEOS_FAIL,
  GET_YOUTUBE_VIDEO_DETAILS,
  GET_YOUTUBE_VIDEO_DETAILS_SUCCESS,
  GET_YOUTUBE_VIDEO_DETAILS_FAIL,
  CREATE_YOUTUBE_VIDEO,
  CREATE_YOUTUBE_VIDEO_SUCCESS,
  CREATE_YOUTUBE_VIDEO_FAIL,
  UPDATE_YOUTUBE_VIDEO,
  UPDATE_YOUTUBE_VIDEO_SUCCESS,
  UPDATE_YOUTUBE_VIDEO_FAIL,
  DELETE_YOUTUBE_VIDEO,
  DELETE_YOUTUBE_VIDEO_SUCCESS,
  DELETE_YOUTUBE_VIDEO_FAIL,
 
} from "./actionTypes"

const INIT_STATE = {

  youtubeVideos: {
    youtubeVideos: [],
    total: "",
    page: "",
  },
  youtubeVideoDetails: {},
  error: {},
  loading: false,
}

const YoutubeVideo = (state = INIT_STATE, action) => {
  switch (action.type) {
    // YoutubeVideo - This line cannot be edited or removed
    case GET_YOUTUBE_VIDEOS:
    case GET_YOUTUBE_VIDEO_DETAILS:
    case CREATE_YOUTUBE_VIDEO:
    case UPDATE_YOUTUBE_VIDEO:
    case DELETE_YOUTUBE_VIDEO:
      return {
        ...state,
        loading: true,
      }

    case DELETE_YOUTUBE_VIDEO_FAIL:
    case GET_YOUTUBE_VIDEOS_FAIL:
    case GET_YOUTUBE_VIDEO_DETAILS_FAIL:
    case UPDATE_YOUTUBE_VIDEO_FAIL:
    case CREATE_YOUTUBE_VIDEO_FAIL:
      return {
        ...state,
        error: action.payload,
        loading: false,
      }

    case GET_YOUTUBE_VIDEOS_SUCCESS:
      return {
        ...state,
        youtubeVideos: action.payload,
        error: {},
        loading: false,
      }

    case GET_YOUTUBE_VIDEO_DETAILS_SUCCESS:
      return {
        ...state,
        youtubeVideoDetails: action.payload,
        error: {},
        loading: false,
      }

    case CREATE_YOUTUBE_VIDEO_SUCCESS:
      return {
        ...state,
        youtubeVideos: {
          ...state.youtubeVideos,
          youtubeVideos: [action.payload, ...state.youtubeVideos.youtubeVideos],
          total: state.youtubeVideos.total + 1,
        },
        youtubeVideoDetails: action.payload,
        error: {},
        loading: false,
      }

    case UPDATE_YOUTUBE_VIDEO_SUCCESS:
      return {
        ...state,
        youtubeVideos: {
          ...state.youtubeVideos,
          youtubeVideos: state.youtubeVideos.youtubeVideos.map(client =>
            client._id === action.payload._id
              ? { ...client, ...action.payload }
              : client
          ),
        },
        youtubeVideoDetails: action.payload,
        loading: false,
        error: {},
      }

    case DELETE_YOUTUBE_VIDEO_SUCCESS:
      return {
        ...state,
        youtubeVideos: {
          ...state.youtubeVideos,
          youtubeVideos: state.youtubeVideos.youtubeVideos.filter(
            client => client._id !== action.payload._id
          ),
        },
        error: {},
        loading: false,
      }

    default:
      return state
  }
}

export default YoutubeVideo
